

import { Component, HostListener, OnChanges, OnDestroy, OnInit } from '@angular/core';
import {
    NavigationCancel,
    NavigationEnd,
    NavigationError,
    NavigationStart,
    Router,
    Event as RouterEvent,
} from '@angular/router';

import { AppUtilityService } from './core/services/app-utility.service';
import { ConfigService } from './core/services/config.service';
import { DataStoreService } from './core/services/datastore.service';
import { LmsLoaderService } from './core/services/lms-loader.service';
import { LmsMenuService } from './core/services/lms-menu.service';
import { LmsTabsDragDropService } from './core/services/lms-tabs-drag-drop.service';
import { PopupService } from './core/services/popup.service';
import { SystemInitService } from './core/services/system-init.service';
import { TabService } from './core/services/tab.service';

/**
 * Bootstrap Component
 * @export
 * @class AppComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
    selector: 'lms-app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy, OnChanges {
    // // Sets initial value to true to show loading spinner on first load
    loading: Boolean;
    private loadingSubscription;
    private configData;
    private dropEndSubscription;
    showHeader: Boolean;

    /**
     * Creates an instance of AppComponent.
     * @param {Router} router
     * @param {SystemInitService} systemInitService
     * @param {LmsLoaderService} lmsLoaderService
     * @param {LmsTabsDragDropService} lmsTabsDragDropService
     * @param {TabService} tabService
     * @param {DataStoreService} dataStoreService
     * @param {PopupService} popUpSerives
     * @param {ConfigService} configService
     * @param {LmsMenuService} lmsMenuService
     *
     * @memberOf AppComponent
     */
    constructor(private router: Router,
        private systemInitService: SystemInitService,
        private lmsLoaderService: LmsLoaderService,
        private lmsTabsDragDropService: LmsTabsDragDropService,
        private tabService: TabService,
        private dataStoreService: DataStoreService,
        private popUpSerives: PopupService,
        private configService: ConfigService,
        private lmsMenuService: LmsMenuService,
        private appUtilService: AppUtilityService) {
        this.configData = this.configService.getConfigData();

        this.loadingSubscription = this.lmsLoaderService.isLoading.subscribe(data => {
            console.log(data);
            this.loading = data;
        });

        router.events.subscribe((event: RouterEvent) => {
            this.navigationInterceptor(event);
        });

        switch (this.getParameterByName('showHeader')) {
            case 'false':
                this.showHeader = false;
                break;
            default:
                this.showHeader = true;
                break;
        }
    }


    // Shows and hides the loading spinner during RouterEvent changes
    navigationInterceptor(event: RouterEvent): void {
        if (event instanceof NavigationStart) {
            // this.loading = true;
        }
        if (event instanceof NavigationEnd) {
            const windowHeight = window.innerHeight;
            let heightToAdjust = 0;
            if (window.innerWidth < 1280) {
                heightToAdjust = 22;
            }
            const leftMenuItems = document.getElementById('leftMenuItems');
            if (windowHeight && leftMenuItems) {
                leftMenuItems.removeAttribute('style');
                leftMenuItems.style.maxHeight = (windowHeight) + 'px';
                leftMenuItems.style.minHeight = ' ' + (windowHeight - 36 - heightToAdjust) + 'px';
            }
        }

        // Set loading state to false in both of the below events to hide the spinner in case a request fails
        if (event instanceof NavigationCancel) {
            this.loading = false;
        }
        if (event instanceof NavigationError) {
            this.loading = false;
        }
    }


    /**
     * @memberOf AppComponent
     */
    ngOnInit() {
        if (localStorage.getItem('lms_app_location') == null) {
            localStorage.setItem('lms_app_location', window.location.href);
        }
        this.systemInitService.init();
    }

    /**
     * @memberOf AppComponent
     */
    ngOnChanges() {

    }

    /**
     * @memberOf AppComponent
     */
    ngOnDestroy() {
        this.loadingSubscription.unsubscribe();
        this.dropEndSubscription.unsubscribe();
    }


    getParameterByName(name: string, url?: string) {
        if (!url) {
            url = window.location.href;
        }
        name = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) { return null; };
        if (!results[2]) { return ''; };
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
    /**
     * This is default enter key functionality
     * @param {any} event
     * @memberOf AppComponent
     */
    @HostListener('window:keydown', ['$event']) defaultEnterFunctionality(event) {
        if (event && (event.key === 'Enter' || event.key === 'F5')) {
            event.preventDefault();
            event.stopPropagation();
            if (event.key === 'F5' && this.popUpSerives.getPageMode().toUpperCase() !== 'DIALOG') {
                const submitBtn = document.getElementById('defaultSearchButton');
                if (submitBtn) {
                    submitBtn.click();
                }
            } else if (event.key === 'Enter') {
                const pageMode = this.popUpSerives.getPageMode();
                const submitBtnId = this.popUpSerives.getSubmitBtnId();

                const submitBtn = document.getElementById(submitBtnId);
                // this.appUtilService.removeFilterTextBoxValue();
                if (submitBtn) {
                    submitBtn.click();
                    // if (pageMode && pageMode.toUpperCase() === 'DIALOG') {
                    //     submitBtn.focus();
                    // }
                }

                if (pageMode && pageMode.toUpperCase() === 'READ') {
                    setTimeout(() => {
                        const errorElement = document.getElementById('message-text');
                        if (null === errorElement && submitBtn) {
                            submitBtn.focus();
                        }
                    }, 100);
                }
            }
        }
    }
}
